// @ts-strict-ignore
import { DOCUMENT } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { uniqueId } from 'lodash-es';
import { timer } from 'rxjs';
import { DEFAULT_LANGUAGE } from '../../../../app.constants';
import { UI_STRINGS } from '../../../../functions/language/uistrings';
import { Language } from '../../../../model/enums/language';
import { FEEDBACK_BUTTON_ID } from '../../../../public/dashboard/shared/dashboard.constants';
import { ClickOutsideEvent } from '../../directives/click-outside.directive';

@Component({
  selector: 'app-slide-out-tab',
  templateUrl: './slide-out-tab.component.html',
  styleUrls: ['./slide-out-tab.component.scss'],
  standalone: false,
})
export class SlideOutTabComponent implements OnChanges {
  @Input() caption: string;
  @Input() isSlideOutTabOpen: boolean;
  @Input() lang: Language = DEFAULT_LANGUAGE;
  @Input() name: string = uniqueId('slideout');

  @Output() openStateChanged: EventEmitter<boolean> = new EventEmitter();

  @ViewChild('closeButton') closeButton: ElementRef<HTMLButtonElement>;

  readonly CLOSE_STRING = UI_STRINGS.GLOBAL.CLOSE;

  constructor(@Inject(DOCUMENT) private _document: Document) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.isSlideOutTabOpen?.currentValue) {
      timer(0).subscribe(() => this.closeButton?.nativeElement?.focus());
    }
  }

  close(event?: ClickOutsideEvent): void {
    const feedbackButtonWasClicked = event?.clickedElement?.id === FEEDBACK_BUTTON_ID;

    if (feedbackButtonWasClicked || !this.isSlideOutTabOpen) {
      return;
    }
    this._document.getElementById(FEEDBACK_BUTTON_ID)?.focus();
    this.openStateChanged.emit(false);
  }
}
